import {MediaWithType} from "./MediaWithType";

export enum VendorCategory {
  REAL_ESTATE_SERVICES = "REAL_ESTATE_SERVICES",
  CASH_BUYERS_AND_INSTANT_OFFERS = "CASH_BUYERS_AND_INSTANT_OFFERS",
  CREDIT_COUNSELING = "CREDIT_COUNSELING",
  FLOOD_INSURANCE = "FLOOD_INSURANCE",
  HOME_INSPECTORS = "HOME_INSPECTORS",
  HOMEOWNERS_INSURANCE = "HOMEOWNERS_INSURANCE",
  HOME_STAGERS = "HOME_STAGERS",
  HOME_WARRANTY = "HOME_WARRANTY",
  LAND_SURVEYORS = "LAND_SURVEYORS",
  MORTGAGE_INSURANCE = "MORTGAGE_INSURANCE",
  MORTGAGE_LENDING = "MORTGAGE_LENDING",
  PHOTOGRAPHY_VIRTUAL_TOURS = "PHOTOGRAPHY_VIRTUAL_TOURS",
  PROPERTY_MANAGEMENT = "PROPERTY_MANAGEMENT",
  PROPERTY_TAX_SERVICES = "PROPERTY_TAX_SERVICES",
  REAL_ESTATE_AGENTS = "REAL_ESTATE_AGENTS",
  REAL_ESTATE_ATTORNEYS = "REAL_ESTATE_ATTORNEYS",
  TITLE_ESCROW_SERVICES = "TITLE_ESCROW_SERVICES",
  APPLIANCES_SYSTEMS = "APPLIANCES_SYSTEMS",
  AIR_CONDITIONING_HEATING = "AIR_CONDITIONING_HEATING",
  APPLIANCE_SERVICERS = "APPLIANCE_SERVICERS",
  ELECTRICIANS = "ELECTRICIANS",
  ELECTRICITY_PROVIDERS = "ELECTRICITY_PROVIDERS",
  HOME_AUTOMATION_HOME_MEDIA = "HOME_AUTOMATION_HOME_MEDIA",
  NATURAL_GAS_PROVIDERS = "NATURAL_GAS_PROVIDERS",
  PLUMBERS = "PLUMBERS",
  PROPANE_PROVIDERS = "PROPANE_PROVIDERS",
  SEPTIC_TANK_SYSTEMS = "SEPTIC_TANK_SYSTEMS",
  SOLAR_ENERGY_SYSTEMS = "SOLAR_ENERGY_SYSTEMS",
  HOME_SERVICES = "HOME_SERVICES",
  ARCHITECTS_BUILDING_DESIGNERS = "ARCHITECTS_BUILDING_DESIGNERS",
  CLOSET_DESIGNERS_PROFESSIONAL_ORGANIZERS = "CLOSET_DESIGNERS_PROFESSIONAL_ORGANIZERS",
  DESIGN_BUILD_FIRMS = "DESIGN_BUILD_FIRMS",
  GENERAL_CONTRACTORS = "GENERAL_CONTRACTORS",
  HANDYMAN = "HANDYMAN",
  HOME_BUILDERS = "HOME_BUILDERS",
  HOME_MONITORING_SECURITY = "HOME_MONITORING_SECURITY",
  INSULATION = "INSULATION",
  INTERIOR_DESIGNERS_DECORATORS = "INTERIOR_DESIGNERS_DECORATORS",
  KITCHEN_BATHROOM_DESIGNERS = "KITCHEN_BATHROOM_DESIGNERS",
  LOCKSMITHS = "LOCKSMITHS",
  PAINTERS = "PAINTERS",
  PAINT_AND_WALL_COVERINGS = "PAINT_AND_WALL_COVERINGS",
  ROOFING_GUTTERS = "ROOFING_GUTTERS",
  WINDOW_TREATMENTS = "WINDOW_TREATMENTS",
  CLEANING = "CLEANING",
  AIR_DUCT_CLEANING = "AIR_DUCT_CLEANING",
  CARPET_UPHOLSTERY_CLEANING = "CARPET_UPHOLSTERY_CLEANING",
  CHIMNEY_CLEANERS = "CHIMNEY_CLEANERS",
  EXTERIOR_CLEANERS = "EXTERIOR_CLEANERS",
  HOUSE_CLEANERS = "HOUSE_CLEANERS",
  JUNK_REMOVAL = "JUNK_REMOVAL",
  PEST_CONTROL = "PEST_CONTROL",
  WINDOW_CLEANERS = "WINDOW_CLEANERS",
  OUTDOOR = "OUTDOOR",
  ASPHALT_PAVING_COMPANIES = "ASPHALT_PAVING_COMPANIES",
  DECKS_PATIO_OUTDOOR_ENCLOSURES = "DECKS_PATIO_OUTDOOR_ENCLOSURES",
  DRIVEWAY_INSTALLATION_MAINTENANCE = "DRIVEWAY_INSTALLATION_MAINTENANCE",
  FENCE_CONTRACTORS = "FENCE_CONTRACTORS",
  GARDENERS_LAWN_CARE = "GARDENERS_LAWN_CARE",
  GARDEN_AND_LANDSCAPE_SUPPLIES = "GARDEN_AND_LANDSCAPE_SUPPLIES",
  HOT_TUB_SPA_DEALERS = "HOT_TUB_SPA_DEALERS",
  IRRIGATION_SPECIALIST = "IRRIGATION_SPECIALIST",
  LANDSCAPE_ARCHITECTS_DESIGNERS = "LANDSCAPE_ARCHITECTS_DESIGNERS",
  LANDSCAPE_CONTRACTORS = "LANDSCAPE_CONTRACTORS",
  OUTDOOR_LIGHTING_AUDIO_VISUAL_SYSTEMS = "OUTDOOR_LIGHTING_AUDIO_VISUAL_SYSTEMS",
  OUTDOOR_PLAY_SYSTEMS = "OUTDOOR_PLAY_SYSTEMS",
  PRESSURE_WASHING = "PRESSURE_WASHING",
  SPA_AND_POOL_MAINTENANCE = "SPA_AND_POOL_MAINTENANCE",
  SWIMMING_POOL_BUILDERS = "SWIMMING_POOL_BUILDERS",
  TREE_SERVICES = "TREE_SERVICES",
  REMODELING = "REMODELING",
  BUILDING_SUPPLIES = "BUILDING_SUPPLIES",
  FIREPLACES = "FIREPLACES",
  GARAGE_DOOR_REPAIR = "GARAGE_DOOR_REPAIR",
  GARAGE_DOOR_SALES = "GARAGE_DOOR_SALES",
  KITCHEN_BATHROOM_REMODELERS = "KITCHEN_BATHROOM_REMODELERS",
  REMODELING_CONTRACTORS = "REMODELING_CONTRACTORS",
  SIDING_EXTERIORS = "SIDING_EXTERIORS",
  SPECIALTY_CONTRACTORS = "SPECIALTY_CONTRACTORS",
  STAIRCASES_RAILINGS = "STAIRCASES_RAILINGS",
  STONE_PAVERS_CONCRETE = "STONE_PAVERS_CONCRETE",
  TILE_STONE_COUNTERTOPS = "TILE_STONE_COUNTERTOPS",
  RENOVATION = "RENOVATION",
  BEDDING_BATH = "BEDDING_BATH",
  CABINETS_CABINETRY = "CABINETS_CABINETRY",
  CARPENTERS = "CARPENTERS",
  CARPET_DEALERS = "CARPET_DEALERS",
  DOOR_DEALERS = "DOOR_DEALERS",
  DRYWALL_CONTRACTORS = "DRYWALL_CONTRACTORS",
  ENVIRONMENTAL_SERVICES_RESTORATION = "ENVIRONMENTAL_SERVICES_RESTORATION",
  EXCAVATION_CONTRACTORS = "EXCAVATION_CONTRACTORS",
  FLOORING_CONTRACTORS = "FLOORING_CONTRACTORS",
  FURNITURE_ACCESSORIES = "FURNITURE_ACCESSORIES",
  FURNITURE_REPAIR_UPHOLSTERY = "FURNITURE_REPAIR_UPHOLSTERY",
  GLASS_SHOWER_DOOR_DEALERS = "GLASS_SHOWER_DOOR_DEALERS",
  IRONWORK = "IRONWORK",
  KITCHEN_BATH_FIXTURES = "KITCHEN_BATH_FIXTURES",
  LIGHTING = "LIGHTING",
  WINDOW_CONTRACTORS = "WINDOW_CONTRACTORS"
}

export const VendorCategoryLabel: Record<VendorCategory, string> = {
  [VendorCategory.REAL_ESTATE_SERVICES]: "Real Estate Services",
  [VendorCategory.CASH_BUYERS_AND_INSTANT_OFFERS]: "Cash Buyers & Instant Offers",
  [VendorCategory.CREDIT_COUNSELING]: "Credit Counseling",
  [VendorCategory.FLOOD_INSURANCE]: "Flood Insurance",
  [VendorCategory.HOME_INSPECTORS]: "Home Inspectors",
  [VendorCategory.HOMEOWNERS_INSURANCE]: "Homeowners Insurance",
  [VendorCategory.HOME_STAGERS]: "Home Stagers",
  [VendorCategory.HOME_WARRANTY]: "Home Warranty",
  [VendorCategory.LAND_SURVEYORS]: "Land Surveyors",
  [VendorCategory.MORTGAGE_INSURANCE]: "Mortgage Insurance",
  [VendorCategory.MORTGAGE_LENDING]: "Mortgage & Lending",
  [VendorCategory.PHOTOGRAPHY_VIRTUAL_TOURS]: "Photography & Virtual Tours",
  [VendorCategory.PROPERTY_MANAGEMENT]: "Property Management",
  [VendorCategory.PROPERTY_TAX_SERVICES]: "Property Tax Services",
  [VendorCategory.REAL_ESTATE_AGENTS]: "Real Estate Agents",
  [VendorCategory.REAL_ESTATE_ATTORNEYS]: "Real Estate Attorneys",
  [VendorCategory.TITLE_ESCROW_SERVICES]: "Title & Escrow Services",
  [VendorCategory.APPLIANCES_SYSTEMS]: "Appliances & Systems",
  [VendorCategory.AIR_CONDITIONING_HEATING]: "Air Conditioning & Heating",
  [VendorCategory.APPLIANCE_SERVICERS]: "Appliance Servicers",
  [VendorCategory.ELECTRICIANS]: "Electricians",
  [VendorCategory.ELECTRICITY_PROVIDERS]: "Electricity Providers",
  [VendorCategory.HOME_AUTOMATION_HOME_MEDIA]: "Home Automation & Home Media",
  [VendorCategory.NATURAL_GAS_PROVIDERS]: "Natural Gas Providers",
  [VendorCategory.PLUMBERS]: "Plumbers",
  [VendorCategory.PROPANE_PROVIDERS]: "Propane Providers",
  [VendorCategory.SEPTIC_TANK_SYSTEMS]: "Septic Tank Systems",
  [VendorCategory.SOLAR_ENERGY_SYSTEMS]: "Solar Energy Systems",
  [VendorCategory.HOME_SERVICES]: "Home Services",
  [VendorCategory.ARCHITECTS_BUILDING_DESIGNERS]: "Architects & Building Designers",
  [VendorCategory.CLOSET_DESIGNERS_PROFESSIONAL_ORGANIZERS]: "Closet Designers & Professional Organizers",
  [VendorCategory.DESIGN_BUILD_FIRMS]: "Design-Build Firms",
  [VendorCategory.GENERAL_CONTRACTORS]: "General Contractors",
  [VendorCategory.HANDYMAN]: "Handyman",
  [VendorCategory.HOME_BUILDERS]: "Home Builders",
  [VendorCategory.HOME_MONITORING_SECURITY]: "Home Monitoring & Security",
  [VendorCategory.INSULATION]: "Insulation",
  [VendorCategory.INTERIOR_DESIGNERS_DECORATORS]: "Interior Designers & Decorators",
  [VendorCategory.KITCHEN_BATHROOM_DESIGNERS]: "Kitchen & Bathroom Designers",
  [VendorCategory.LOCKSMITHS]: "Locksmiths",
  [VendorCategory.PAINTERS]: "Painters",
  [VendorCategory.PAINT_AND_WALL_COVERINGS]: "Paint & Wall Coverings",
  [VendorCategory.ROOFING_GUTTERS]: "Roofing & Gutters",
  [VendorCategory.WINDOW_TREATMENTS]: "Window Treatments",
  [VendorCategory.CLEANING]: "Cleaning",
  [VendorCategory.AIR_DUCT_CLEANING]: "Air Duct Cleaning",
  [VendorCategory.CARPET_UPHOLSTERY_CLEANING]: "Carpet & Upholstery Cleaners",
  [VendorCategory.CHIMNEY_CLEANERS]: "Chimney Cleaners",
  [VendorCategory.EXTERIOR_CLEANERS]: "Exterior Cleaners",
  [VendorCategory.HOUSE_CLEANERS]: "House Cleaners",
  [VendorCategory.JUNK_REMOVAL]: "Junk Removal",
  [VendorCategory.PEST_CONTROL]: "Pest Control",
  [VendorCategory.WINDOW_CLEANERS]: "Window Cleaners",
  [VendorCategory.OUTDOOR]: "Outdoor",
  [VendorCategory.ASPHALT_PAVING_COMPANIES]: "Asphalt & Paving Companies",
  [VendorCategory.DECKS_PATIO_OUTDOOR_ENCLOSURES]: "Decks, Patios & Outdoor Enclosures",
  [VendorCategory.DRIVEWAY_INSTALLATION_MAINTENANCE]: "Driveway Installation & Maintenance",
  [VendorCategory.FENCE_CONTRACTORS]: "Fence Contractors",
  [VendorCategory.GARDENERS_LAWN_CARE]: "Gardeners & Lawn Care",
  [VendorCategory.GARDEN_AND_LANDSCAPE_SUPPLIES]: "Garden & Landscape Supplies",
  [VendorCategory.HOT_TUB_SPA_DEALERS]: "Hot Tub & Spa Dealers",
  [VendorCategory.IRRIGATION_SPECIALIST]: "Irrigation Specialist",
  [VendorCategory.LANDSCAPE_ARCHITECTS_DESIGNERS]: "Landscape Architects & Landscape Designers",
  [VendorCategory.LANDSCAPE_CONTRACTORS]: "Landscape Contractors",
  [VendorCategory.OUTDOOR_LIGHTING_AUDIO_VISUAL_SYSTEMS]: "Outdoor Lighting & Audio Visual Systems",
  [VendorCategory.OUTDOOR_PLAY_SYSTEMS]: "Outdoor Play Systems",
  [VendorCategory.PRESSURE_WASHING]: "Pressure Washing",
  [VendorCategory.SPA_AND_POOL_MAINTENANCE]: "Spa & Pool Maintenance",
  [VendorCategory.SWIMMING_POOL_BUILDERS]: "Swimming Pool Builders",
  [VendorCategory.TREE_SERVICES]: "Tree Services",
  [VendorCategory.REMODELING]: "Remodeling",
  [VendorCategory.BUILDING_SUPPLIES]: "Building Supplies",
  [VendorCategory.FIREPLACES]: "Fireplaces",
  [VendorCategory.GARAGE_DOOR_REPAIR]: "Garage Door Repair",
  [VendorCategory.GARAGE_DOOR_SALES]: "Garage Door Sales",
  [VendorCategory.KITCHEN_BATHROOM_REMODELERS]: "Kitchen & Bathroom Remodelers",
  [VendorCategory.REMODELING_CONTRACTORS]: "Remodeling Contractors",
  [VendorCategory.SIDING_EXTERIORS]: "Siding & Exteriors",
  [VendorCategory.SPECIALTY_CONTRACTORS]: "Specialty Contractors",
  [VendorCategory.STAIRCASES_RAILINGS]: "Staircases & Railings",
  [VendorCategory.STONE_PAVERS_CONCRETE]: "Stone, Pavers & Concrete",
  [VendorCategory.TILE_STONE_COUNTERTOPS]: "Tile, Stone & Countertops",
  [VendorCategory.RENOVATION]: "Renovation",
  [VendorCategory.BEDDING_BATH]: "Bedding & Bath",
  [VendorCategory.CABINETS_CABINETRY]: "Cabinets & Cabinetry",
  [VendorCategory.CARPENTERS]: "Carpenters",
  [VendorCategory.CARPET_DEALERS]: "Carpet Dealers",
  [VendorCategory.DOOR_DEALERS]: "Door Dealers",
  [VendorCategory.DRYWALL_CONTRACTORS]: "Drywall Contractors",
  [VendorCategory.ENVIRONMENTAL_SERVICES_RESTORATION]: "Environmental Services & Restoration",
  [VendorCategory.EXCAVATION_CONTRACTORS]: "Excavation Contractors",
  [VendorCategory.FLOORING_CONTRACTORS]: "Flooring Contractors",
  [VendorCategory.FURNITURE_ACCESSORIES]: "Furniture & Accessories",
  [VendorCategory.FURNITURE_REPAIR_UPHOLSTERY]: "Furniture Repair & Upholstery",
  [VendorCategory.GLASS_SHOWER_DOOR_DEALERS]: "Glass & Shower Door Dealers",
  [VendorCategory.IRONWORK]: "Ironwork",
  [VendorCategory.KITCHEN_BATH_FIXTURES]: "Kitchen & Bath Fixtures",
  [VendorCategory.LIGHTING]: "Lighting",
  [VendorCategory.WINDOW_CONTRACTORS]: "Window Contractors"
};

export enum VendorType {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY"
}

export interface Vendor {
  type: VendorType;
  logoMedia?: MediaWithType;
  name?: string;
  email?: string;
  phone?: string;
  companyName?: string;
  nmlsId?: string;
  category?: VendorCategory;
}
